import { OnboardingTitle as OnboardingTitleBase } from 'registration/containers/Onboarding';

import { withStyle } from 'shared/components/ihcl/styled';

export const OnboardingTitle = withStyle(OnboardingTitleBase, {
  marginBottom: 0,
});
